export const Theme = {
  orange: '#FF9900',
  white: '#fff',
  darkgrey: '#424242',
  lightgrey: '#c9c7c7',
  mediumgrey: '#BCBCBC',
  blue: '#3299BB',
};
